/* eslint-disable */
import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom"; // ✅ add useNavigate
import DashIcon from "components/icons/DashIcon";

export function SidebarLinks(props) {
  let location = useLocation();
  const navigate = useNavigate(); // ✅ add this

  const { routes, onMenuItemClick } = props;

  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  const handleLinkClick = () => {
    if (onMenuItemClick) {
      onMenuItemClick();
    }
  };

  // ✅ Logout handler — no props needed
  const handleLogout = () => {
    localStorage.removeItem("token"); // or localStorage.clear()
    navigate("/auth/sign-in");
  };

  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (
        route.layout === "/admin" ||
        route.layout === "/auth" ||
        route.layout === "/rtl"
      ) {

        // ✅ Intercept logout route
        if (route.isLogout) {
          return (
            <div
              key={index}
              onClick={handleLogout}
              className="relative mb-3 flex hover:cursor-pointer"
            >
              <li className="my-[3px] flex cursor-pointer items-center px-8">
                <span className="font-medium text-gray-600">
                  {route.icon ? route.icon : <DashIcon />}
                </span>
                <p className="leading-1 ml-4 flex font-medium text-gray-600">
                  {route.name}
                </p>
              </li>
            </div>
          );
        }

        // Normal routes unchanged
        return (
          <Link
            key={index}
            to={route.layout + "/" + route.path}
            onClick={handleLinkClick}
          >
            <div className="relative mb-3 flex hover:cursor-pointer">
              <li
                className="my-[3px] flex cursor-pointer items-center px-8"
                key={index}
              >
                <span
                  className={`${activeRoute(route.path) === true
                      ? "font-bold text-[#014d4d] dark:text-white"
                      : "font-medium text-gray-600"
                    }`}
                >
                  {route.icon ? route.icon : <DashIcon />}{" "}
                </span>
                <p
                  className={`leading-1 ml-4 flex ${activeRoute(route.path) === true
                      ? "font-bold text-navy-700 dark:text-white"
                      : "font-medium text-gray-600"
                    }`}
                >
                  {route.name}
                </p>
              </li>
              {activeRoute(route.path) ? (
                <div className="absolute right-0 top-px h-9 w-1 rounded-lg bg-[#014d4d] dark:bg-brand-400" />
              ) : null}
            </div>
          </Link>
        );
      }
    });
  };

  return createLinks(routes);
}

export default SidebarLinks;
